
export const states = [
  { region_code: 'AC', name: 'Acre' },
  { region_code: 'AL', name: 'Alagoas' },
  { region_code: 'AP', name: 'Amapá' },
  { region_code: 'AM', name: 'Amazonas' },
  { region_code: 'BA', name: 'Bahia' },
  { region_code: 'CE', name: 'Ceará' },
  { region_code: 'DF', name: 'Distrito Federal' },
  { region_code: 'ES', name: 'Espírito Santo' },
  { region_code: 'GO', name: 'Goiás' },
  { region_code: 'MA', name: 'Maranhão' },
  { region_code: 'MT', name: 'Mato Grosso' },
  { region_code: 'MS', name: 'Mato Grosso do Sul' },
  { region_code: 'MG', name: 'Minas Gerais' },
  { region_code: 'PA', name: 'Pará' },
  { region_code: 'PB', name: 'Paraíba' },
  { region_code: 'PR', name: 'Paraná' },
  { region_code: 'PE', name: 'Pernambuco' },
  { region_code: 'PI', name: 'Piauí' },
  { region_code: 'RJ', name: 'Rio de Janeiro' },
  { region_code: 'RN', name: 'Rio Grande do Norte' },
  { region_code: 'RS', name: 'Rio Grande do Sul' },
  { region_code: 'RO', name: 'Rondônia' },
  { region_code: 'RR', name: 'Roraima' },
  { region_code: 'SC', name: 'Santa Catarina' },
  { region_code: 'SP', name: 'São Paulo' },
  { region_code: 'SE', name: 'Sergipe' },
  { region_code: 'TO', name: 'Tocantins' },
]